import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { createUseStyles } from 'react-jss';
import { ThemeContext } from 'styled-components';

import { getBreakpointFromManor } from 'ctm-components';

// manor
import { Typography } from '@comparethemarketau/manor-typography';

const useStyles = createUseStyles((theme) => ({
    title: {
        color: theme.colors.primary900,
        fontWeight: theme.fontWeight.normal,
        extend: ({ breakpoint }) => {
            if (breakpoint === 'xs' || breakpoint === 'sm') {
                return {
                    fontSize: theme.fontSize['2xl'],
                    lineHeight: '2.7rem'
                };
            }
            return {
                fontSize: theme.fontSize['5xl'],
                lineHeight: '4rem'
            };
        }
    }
}));

const ErrorTitle = (props) => {
    const breakpoint = getBreakpointFromManor();
    const theme = useContext(ThemeContext);
    const classes = useStyles({ theme, breakpoint });
    const { className } = props;

    return (
        <Typography className={classNames(classes.title, className)}>
            {'Oops, something went wrong.'}
        </Typography>
    );
};

ErrorTitle.propTypes = {
    className: PropTypes.string
};

export { ErrorTitle };
